import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { IComparisonCountry } from "../interfaces/icomparisoncountry";
import { ApplicationSettingsService } from "./applicationsettings.service";
import { BaseService } from "./base.service";
import { AuthService } from "./auth.service";
import { IMultiCountry } from "../interfaces/imulticountry";

@Injectable()
export class CountryComparisonService extends BaseService {
    constructor(http: HttpClient,
        private applicationSettings: ApplicationSettingsService,
        authService: AuthService,
        toastsManager: ToastrService) {
        super(http, authService, toastsManager);
    }

    /**
     * Gets country comparison based on list of country codes
     * @param countryCodes
     */
    getCountryComparison(countryCodes: string[]): Observable<any[]> {
        let selectedCountries: string[] = [];
        countryCodes.forEach(code => {
            if (code == null || code == undefined) {
                code = "";
            }
            selectedCountries.push(code);
        });

        if (selectedCountries.length === 0) {
            return throwError('No valid country codes provided');
        }

        return super.post(`${this.applicationSettings.apiUrl}CountryComparison/GetCountryComparison`, selectedCountries);
    }
    getMultiCountry(countryCode: String): Observable<IMultiCountry> {
        return super.get(`${this.applicationSettings.apiUrl}CountryComparison/GetMultiCountry`);
    }

    /**
     * Gets country based on supplied code, returns an IComparisonCountry object
     * @param countryCode
     */
    getComparisonCountry(countryCode: String): Observable<IComparisonCountry> {
        return super.get(`${this.applicationSettings.apiUrl}CountryComparison/${countryCode}`);
    }
    downloadMultiCountryComparison(countryCodes: string[]): Observable<any> {
        let url: string = `${this.applicationSettings.apiUrl}download/downloadMultiCountryComparison/`;
        return super.postWithContentType(url, "application/json;charset=UTF-8", countryCodes);
    }
}